__turbopack_context__.v({
  "canceled": "corporateRowWrapper-module-scss-module__6yx40G__canceled",
  "rowBlur": "corporateRowWrapper-module-scss-module__6yx40G__rowBlur",
});
